import { render, staticRenderFns } from "./app.vue?vue&type=template&id=f9a0fcb4&scoped=true&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a0fcb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\plan_action\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9a0fcb4')) {
      api.createRecord('f9a0fcb4', component.options)
    } else {
      api.reload('f9a0fcb4', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=f9a0fcb4&scoped=true&", function () {
      api.rerender('f9a0fcb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app.vue"
export default component.exports